<span class="tt-gantt-button" [matTooltip]="displayTooltipText">
    <button
        type="button"
        class="tt-gantt-button__control"
        [class.tt-gantt-button__control--selected]="ttModel"
        [class.tt-gantt-button__control--loading]="ttLoading"
        [disabled]="ttDisabled || ttLoading"
        [attr.aria-pressed]="ttModel"
        [attr.aria-busy]="ttLoading ? 'true' : null"
        [attr.aria-label]="displayText || displayTooltipText || null"
        (click)="click($event)"
    >
        <span *ngIf="displayIcon" class="tt-gantt-button__icon" [ngClass]="displayIcon" aria-hidden="true"></span>
        <span *ngIf="displayText" class="tt-gantt-button__text">{{ displayText }}</span>
        <!-- <span class="tt-gantt-toggle__indicator fas fa-check" [class.tt-gantt-toggle__indicator--selected]="ttModel" aria-hidden="true"></span> -->
    </button>
</span>
